import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  districts: null,
  loading: false,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { records } = payload;
  const districts = records;

  return {
    ...state,
    districts,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
});
